export default class ThimCountDown extends elementorModules.frontend.handlers.Base {
	onInit() {
		const self = this;
		const $countDown = this.$element.find( '.thim-ekits-countdown-wrapper' );
		if (! $countDown) {
			return;
		}
		this.elements = {
			days: $countDown.find( '.countdown-days' ),
			hours: $countDown.find( '.countdown-hours' ),
			minutes: $countDown.find( '.countdown-minutes' ),
			seconds: $countDown.find( '.countdown-seconds' ),
		};
		this.endTime = new Date( $countDown.data( 'date_end' ) * 1000 );
		setInterval( function() {
			self.updateClock();
		}, 100 );
	}

	updateClock() {
		const self = this,
			timeRemaining = this.getTimeRemaining( this.endTime );
		jQuery.each( timeRemaining.parts, function( timePart ) {
			const $element = self.elements[timePart];
			let value = this.toString();
			if (1 === value.length) {
				value = 0 + value;
			}
			if ($element.length) {
				$element.text( value );
			}
		} );
	}

	getTimeRemaining( endTime ) {
		const timeRemaining = endTime - new Date();
		let seconds = Math.floor( timeRemaining / 1000 % 60 ),
			minutes = Math.floor( timeRemaining / 1000 / 60 % 60 ),
			hours = Math.floor( timeRemaining / ( 1000 * 60 * 60 ) % 24 ),
			days = Math.floor( timeRemaining / ( 1000 * 60 * 60 * 24 ) );
		if (days < 0 || hours < 0 || minutes < 0) {
			seconds = minutes = hours = days = 0;
		}
		return {
			total: timeRemaining,
			parts: {
				days,
				hours,
				minutes,
				seconds,
			},
		};
	}
}
